import React from "react";
import "./DashboardCardLoader.css";

const DashboardCardLoader = ({ count = 3, colSize = 4 }) => {
  return (
    <div className="row mt-3 g-3">
      {Array.from({ length: count }).map((_, i) => (
        <div className={`col-md-${colSize}`} key={i}>
          <div className="dcl-card">
            <div className="dcl-shimmer dcl-accent" />
            <div className="dcl-shimmer dcl-title" />
            <div className="dcl-shimmer dcl-value" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardCardLoader;
